export default __webpack_public_path__ + "static/media/placeholder.42cb9b6a.png";